import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { form } from 'helpers/decorators'
import { apiAssessors } from 'helpers/decorators/api'
import { Title } from '../../../../components/misc'
import { get } from 'lodash'
import { connect } from 'react-redux'
import styles from './affiliations-overview.styl'
import { FormattedMessage } from 'react-intl'
import Textarea from '../../../../components/fields/Textarea/Textarea'
import AffiliationActivity from './AffiliationActivity'

@apiAssessors()
@form({
  disableHook: true,
  dataKey: 'item',
})
@connect(({ auth }) => ({
  authUserId: get(auth, 'user.personId'),
}))
class Affiliation extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    item: PropTypes.any,
    onUpdateWWC: PropTypes.func,
    pristine: PropTypes.bool.isRequired
  }

  handleSubmit = (fields, orgId) => {
    if (!('assessor' in fields)) {
      return
    }
    this.props.onUpdateWWC(get(this.props.item, 'assessor.personId'), orgId, get(fields, 'assessor'))
  }

  displaySubtitle(label, intlKey) {
    return (<Title h4 className={styles.subtitle} intlKey={intlKey}>{label}</Title>)
  }
  displayWWC(name, label, intlKey) {
    return (<Textarea
      name={name}
      label={label}
      intlKey={intlKey}
    />)
  }
  displayCheckbox(checked, label, intlKey) {
    return (
      <label className={checked ? styles.checkboxSelected : ''} htmlFor={intlKey}>
        <input disabled className={styles.checkbox} type="checkbox" name={intlKey} checked={checked} readOnly onClick={event => event.preventDefault()} />
        <FormattedMessage id={intlKey} defaultMessage={label} />
      </label>
    )
  }

  render() {
    const { handleSubmit, item } = this.props

    const activityList = get(item, 'activityList')

    return (
      <div className={styles.affiliationWrapper}>
      <form onSubmit={handleSubmit(fields => this.handleSubmit(fields, get(item, 'organization.id')))}>
        <div className={styles.spaceBetween}>
          <div className={styles.affiliation}>
            <Title h2 className={styles.title} intlKey="label.award_centre">Award Centre</Title>
            <h3>{get(item, 'organization.name')}</h3>
            </div>
        </div>
        <Title h2 className={styles.title} intlKey="label.assessed_activities">Assessed Activities</Title>
        {activityList.map(activity => {
          const { id, universityDegree, tafeQualification, apprenticeship, relevantExperience,
            experience, membership, nonAccreditedTraining, section, activityName, activityCategoryName } = activity
          const key = `${this.props.id}-${id}`
          const data = {}
          data['id'] = get(activity, 'id')
          data[`${key}-publicAvailable`] = get(activity, 'publicAvailable')

          return (
            <div className={styles.activity}>
                <div className={styles.activityDetail}>
                  <h3>{section} - {activityName} - {activityCategoryName}</h3>
                  <AffiliationActivity id={key} form={`affiliation-activity-form-${key}`} activity={data} />
                {this.displaySubtitle('Qualifications', 'label.qualifications')}
                <div className={styles.row}>
                  {this.displayCheckbox(universityDegree, 'University Degree', 'label.university_degree')}
                  {this.displayCheckbox(tafeQualification, 'Tafe Qualification', 'label.tafe_qualification')}
                  {this.displayCheckbox(apprenticeship, 'Apprenticeship', 'label.apprenticeship')}
                  {this.displayCheckbox(experience, 'Experience', 'label.experience')}
                  {this.displayCheckbox(membership, 'Membership', 'label.membership')}
                  {this.displayCheckbox(nonAccreditedTraining, 'Non-accredited training', 'label.non_accredited_training')}
                </div>
                {this.displaySubtitle('Relevant Experience (200 characters)', 'label.relevant_experience')}
                <div className={styles.row}>
                  <p>{relevantExperience}</p>

                </div>
              </div>
            </div>
        )
        })}
      </form>
      </div>
    )
  }
}

export default Affiliation
